import { useGetMerchantDataById } from '@/hooks/requests/merchant/useGetMerchantDataById';
import { useUser } from '@/hooks/useUser';

const DEFAULT_CONTACT_DATA = {
  supportPhone: '+34 932 200 612',
  supportEmail: 'info@nemuru.com',
};

export const useGetSupportContactData = () => {
  const { userEntity } = useUser();

  const merchantId = userEntity?.merchant?.id;
  if (!merchantId) return DEFAULT_CONTACT_DATA;

  const { merchantData, merchantDataLoading } = useGetMerchantDataById(userEntity?.merchant?.id);
  if (!merchantData) return DEFAULT_CONTACT_DATA;

  if (merchantDataLoading)
    return {
      supportPhone: '',
      supportEmail: '',
    };

  return {
    supportPhone: merchantData.brandInformation?.customerSupportPhoneNumber ?? DEFAULT_CONTACT_DATA.supportPhone,
    supportEmail: merchantData.brandInformation?.customerSupportEmail ?? DEFAULT_CONTACT_DATA.supportEmail,
  };
};
